import { IOProps } from 'react-compose-io'
import { SelecaoParceiroExecucaoCiclo } from '../../components/SelecaoParceiroExecucaoCiclo'
import { Typography } from '@material-ui/core'
import { ValidacaoEstruturaCicloIO } from './ValidacaoEstruturaCiclo.IO'

export type ValidacaoEstruturaCicloProps = {}

export function ValidacaoEstruturaCicloView({ _io }: IOProps<ValidacaoEstruturaCicloIO, ValidacaoEstruturaCicloProps>) {
  return (
    <>
      <Typography variant="h5">Validação de Execução de Ciclo</Typography>
      <SelecaoParceiroExecucaoCiclo
        voltarPage={_io.voltarPage}
        subtitulo="Selecione o parceiro para visualizar as execuções de ciclo para validação."
        pageValidarExecucao={_io.pageValidarExecucao}
      />
    </>
  )
}
